import React from "react";
import { PressableOpacity } from "app/components/common";
import ArrowDownIcon from "./ArrowDownIcon";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";
import { FadeIn, FadeOut } from "react-native-reanimated";
import Animated from "react-native-reanimated";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";

interface Props {
  onPress: () => void;
}

const ArrowCircleButton = ({ onPress }: Props) => {
  return (
    <PressableOpacity onPress={onPress}>
      <Animated.View
        entering={isWeb ? undefined : FadeIn}
        exiting={isWeb ? undefined : FadeOut}
        style={{
          backgroundColor: theme.colors["brand.500"],
          alignItems: "center",
          justifyContent: "center",
          height: normalize(40),
          width: normalize(40),
          borderRadius: normalize(20),
          shadowColor: theme.colors["neutral.400"],
          shadowOpacity: 0.1,
          shadowRadius: 4,
          shadowOffset: { width: 0, height: 2 },
          elevation: 1,
        }}
      >
        <ArrowDownIcon color="white" />
      </Animated.View>
    </PressableOpacity>
  );
};

export { ArrowCircleButton };
